import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CONTEXT_SELECTOR_FEATURE_NAME, contextSelectorReducer } from 'account-hybrid/features/context-selector/store';

/**
 * Registers the context-selector STORE FEATURE. It no longer declares anything.
 *
 * 🚨 THE UI IS GONE BUT THE REDUCER IS NOT — do not "finish the job" by deleting this module.
 * `ContextSelectorComponent` and `ContextSelectorLinkComponent` were removed (FTK-7588): the only
 * template that rendered `<ft-context-selector>` belonged to `HubComponent`, which was itself
 * routed nowhere — the `hub` state renders `HubV2Component`. Neither component could mount.
 *
 * The reducer is a different story. `AppEffects.onStartup$` dispatches `addNew` twice and
 * `selectGroup` twice on every authenticated, non-collaborative session
 * (`app/store/effects/app.effects.ts`), so this feature slice is written on EVERY BOOT. Dropping
 * the `forFeature` registration would leave those dispatches writing into an unregistered slice —
 * silent, and only visible much later. `store/reducers/context-selector.reducer.spec.ts` carries
 * the full reachability note and pins the immutability contract that made it matter.
 *
 * Eight of the reducer's handlers (`show`, `hide`, `discardChanges`, `toggleMany`, `toggleSingle`,
 * `setSingle`, `selectAll`, `selectNone`) were only reachable from the deleted UI and are dead now.
 * They are left in place deliberately: removing them is a reducer change with its own immutability
 * risk, and it belongs in a pass that can re-run the NgRx runtime-check gate rather than riding
 * along with a component deletion.
 */
@NgModule({
    imports: [StoreModule.forFeature(CONTEXT_SELECTOR_FEATURE_NAME, contextSelectorReducer)],
})
export class ContextSelectorModule {
}
